import React, { useContext, useMemo } from 'react';
import get from 'lodash/get';
import set from 'lodash/set';

import Dropdown from 'src/presentation/components/forms/Dropdown';
import { ExternalAppsTemplate } from 'src/models/Sidekick/SidekickExternalAppsTemplate';
import FormContext from 'src/presentation/contexts/FormContext';
import { HalfRow } from './Layout';
import sidekickExternalAppsTemplatesResource from 'src/actions/sidekick/sidekickExternalAppsTemplatesResource';
import { useResourceAll } from 'src/presentation/hooks/useResource';

type TemplateSelectorProps = {
  'data-aid'?: string;
  attr: string;
  description?: string;
  disabled: boolean;
  typeSpec: any;
};

const TemplateSelector = ({ 'data-aid': dataAid, attr, description, disabled, typeSpec }: TemplateSelectorProps) => {
  const { values: externalAppsTemplates, loadingState } = useResourceAll(sidekickExternalAppsTemplatesResource);
  const { workingState, onBlur, updateState } = useContext(FormContext);

  const baseAttr = `${attr.split('.').slice(0, -1).join('.')}`;

  const options = useMemo(() => {
    return externalAppsTemplates?.map((template: ExternalAppsTemplate) => ({
      label: template.templateDescription,
      value: template.templateId,
    }));
  }, [externalAppsTemplates]);

  if (loadingState === 'loading') {
    return null;
  }
  const value = get(workingState, `${attr}`);
  const handleChange = (templateId: string) => {
    const template = externalAppsTemplates?.find(
      (template: ExternalAppsTemplate) => template.templateId === templateId
    );

    const currentState = set({}, attr, template.templateId) as any;
    set(currentState, `${baseAttr}.namespace`, template?.appNamespace);
    set(currentState, `${baseAttr}.templateInput`, ['']);

    updateState(currentState, { replaceArrayValues: true });

    onBlur && onBlur({ currentState });
  };

  return (
    <HalfRow>
      <Dropdown
        attr={`${attr}.templateId`}
        data-aid={dataAid}
        description={description}
        disabled={disabled}
        fitOpenerWidth={true}
        label={(typeSpec as any).prompt}
        onChange={handleChange}
        options={options}
        placeholder="Select a template"
        value={value}
      />
    </HalfRow>
  );
};

export default TemplateSelector;
